import { Chip } from '@mui/material';
import React from 'react';
import { SIZES } from '../../../../constants/constants';
import { getLabel } from '../../../../utils/multiSelectUtils';
import type { MultiSelectChipsOverflowListItemProps } from '../../types';
import { getOverflowChipSx, stopPropagation } from '../utils';

export function MultiSelectChipsOverflowListItem({
    value,
    onRemove,
    readOnly = false,
    stopOverflowPropagation = false
}: MultiSelectChipsOverflowListItemProps) {
    const label = getLabel(value);
    const chipSx = getOverflowChipSx(readOnly);
    const onDelete = readOnly || !onRemove ? undefined : () => onRemove(value);
    const onMouseDown = stopOverflowPropagation ? stopPropagation : undefined;

    return <Chip sx={chipSx} label={label} size={SIZES.small} onMouseDown={onMouseDown} onDelete={onDelete} />;
}
